/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { useInput } from "hooks";
import { DecimalInput, DropDown2, Input2 } from "components";
import { Checkbox } from "antd";
export const OfferRecipeTextBuilder = ({
  className,
  value,
  onChange = () => { },
}) => {
  const val = useInput("per serving");
  const recipe = useInput(false);
  const amount = useInput("");
  const from = useInput("");
  const to = useInput("");

  const servingTypes = ["per serving", "per serving, serves", "serves"];

  const type = [
    {
      id: 'per serving',
      title: 'per serving',
    },
    {
      id: 'per serving, serves',
      title: 'per serving, serves',
    },
    {
      id: 'serves',
      title: 'serves',
    },
    {
      id: 'Recipe',
      title: 'Recipe',
    },
    {
      id: 'Meal Suggestion',
      title: 'Meal Suggestion',
    },
  ]

  const handleUpdateValue = ({ recipe, value, amount = '', from = '', to = '' }) => {
    let text = '';
    if (value === 'Recipe' || value === 'Meal Suggestion') {
      onChange(value);
      return;
    }
    if (recipe) {
      text += 'Recipe: ';
    }
    if (value === 'per serving, serves') {
      text += `${amount ? `$${amount}` : ''} per serving, serves${from ? ` ${from}` : ''}${to ? ` to ${to}` : ''}`;
    } else if (value === 'per serving') {
      text += `${amount ? `$${amount}` : ''} per serving`;
    } else if (value === 'serves') {
      text += `serves${from ? ` ${from}` : ''}${to ? ` to ${to}` : ''}`;
    }
    onChange(text.trim());
  };

  useEffect(() => {
    if (value) {
      let isRecipe = false;
      let parsedValue = value;
      let nextType = val.value;
      
      if (value === 'Recipe' || value === 'Meal Suggestion') {
        val.setValue(value);
        recipe.setValue(false);
        amount.setValue('');
        from.setValue('');
        to.setValue('');
        return;
      }

      if (value.startsWith('Recipe')) {
        isRecipe = true;
        parsedValue = value.replace('Recipe: ', '').trim();
      }
      
      // Parse the value to determine type and fields
      if (parsedValue.includes('per serving, serves')) {
        nextType = 'per serving, serves';
        const amountMatch = parsedValue.match(/\$(\d+\.?\d*)/);
        if (amountMatch) {
          amount.setValue(amountMatch[1]);
        }
        // Match pattern: serves {from} to {to}, serves {from}, or serves to {to}
        const servesMatch = parsedValue.match(/serves\s+(?:(\d+)\s*)?(?:to\s+(\d+))?/);
        if (servesMatch) {
          from.setValue(servesMatch[1] || '');
          to.setValue(servesMatch[2] || '');
        }
      } else if (parsedValue.includes('per serving')) {
        nextType = 'per serving';
        const amountMatch = parsedValue.match(/\$(\d+\.?\d*)/);
        if (amountMatch) {
          amount.setValue(amountMatch[1]);
        }
        from.setValue('');
        to.setValue('');
      } else if (parsedValue.includes('serves')) {
        nextType = 'serves';
        amount.setValue('');
        // Match pattern: serves {from} to {to}, serves {from}, or serves to {to}
        const servesMatch = parsedValue.match(/serves\s+(?:(\d+)\s*)?(?:to\s+(\d+))?/);
        if (servesMatch) {
          from.setValue(servesMatch[1] || '');
          to.setValue(servesMatch[2] || '');
        }
      }

      val.setValue(nextType);
      recipe.setValue(isRecipe && servingTypes.includes(nextType));
    }
    return () => { };
  }, [value]);

  return (
    <div className={`${className} mt-1 py-2`}>
      <Title>Offer Text Builder</Title>
      {servingTypes.includes(val.value) && (
        <Container className="mt-2">
          <Checkbox
            checked={recipe.value}
            onChange={(e) => {
              e = e.target.checked;
              recipe.setValue(e);
              handleUpdateValue({ recipe: e, value: val.value, amount: amount.value, from: from.value, to: to.value });
            }}
          >
            Recipe
          </Checkbox>
        </Container>
      )}
      <Container>
        <div style={{ width: 300 }}>
          <DropDown2
            label='Type'
            data={type}
            width={300}
            value={val.value}
            onChange={(e) => {
              val.setValue(e);
              if (!servingTypes.includes(e)) {
                recipe.setValue(false);
                amount.setValue('');
                from.setValue('');
                to.setValue('');
                handleUpdateValue({
                  recipe: false,
                  value: e,
                  amount: '',
                  from: '',
                  to: '',
                });
                return;
              }
              if (e === 'serves') {
                amount.setValue('');
                handleUpdateValue({
                  recipe: recipe.value,
                  value: e,
                  amount: '',
                  from: from.value,
                  to: to.value,
                });
              } else if (e === 'per serving') {
                from.setValue('');
                to.setValue('');
                handleUpdateValue({
                  recipe: recipe.value,
                  value: e,
                  amount: amount.value,
                  from: '',
                  to: '',
                });
              } else {
                handleUpdateValue({
                  recipe: recipe.value,
                  value: e,
                  amount: amount.value,
                  from: from.value,
                  to: to.value,
                });
              }
            }}
          />
        </div>
      </Container>
      <Container>
        <div>
          <DecimalInput
            label={'Amount'}
            disabled={val.value === 'serves' || !servingTypes.includes(val.value)}
            value={amount.value}
            onChange={(e) => {
              amount.setValue(e);
              handleUpdateValue({
                recipe: recipe.value,
                value: val.value,
                amount: e,
                from: from.value,
                to: to.value,
              });
            }}
          />
        </div>
      </Container>
      <Container>
        <div style={{ width: 120}}>
          <Input2
            style={{ width: 60, marginLeft: 10 }}
            label={'From'}
            disabled={val.value === 'per serving' || !servingTypes.includes(val.value)}
            value={from.value}
            onChange={(e) => {
              from.setValue(e);
              handleUpdateValue({
                recipe: recipe.value,
                value: val.value,
                amount: amount.value,
                from: e,
                to: to.value,
              })
            }}
          />
        </div>
        <div className="mt-auto">To</div>
        <div style={{ width: 60, marginLeft: 10 }}>
          <Input2
            label={'To'}
            disabled={val.value === 'per serving' || !servingTypes.includes(val.value)}
            value={to.value}
            onChange={(e) => {
              to.setValue(e);
              handleUpdateValue({
                recipe: recipe.value,
                value: val.value,
                amount: amount.value,
                from: from.value,
                to: e,
              })

            }}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
